module.exports = __webpack_public_path__ + "img/RAR-small.052cbd3.svg";